import React, { useState } from 'react';
import Quiz from './components/Quiz';
import Result from './components/Result';
import Ranking from './components/Ranking';
import { quizSets } from './quizSets';
import './App.css';

function App() {
  const [gameState, setGameState] = useState('start'); // start, quiz, result, ranking
  const [selectedSet, setSelectedSet] = useState(null);
  const [finalScore, setFinalScore] = useState(0);
  const [rankingSetId, setRankingSetId] = useState(null);

  const handleSelectSet = (set) => {
    setSelectedSet(set);
    setGameState('quiz');
    setFinalScore(0);
  };

  const handleQuizComplete = (score) => {
    setFinalScore(score);
    setGameState('result');
  };

  const handleRestart = () => {
    setGameState('start');
    setSelectedSet(null);
    setFinalScore(0);
  };

  const handleShowRanking = (setId = null) => {
    setRankingSetId(setId);
    setGameState('ranking');
  };

  const handleBackToStart = () => {
    setGameState('start');
    setSelectedSet(null);
    setRankingSetId(null);
  };

  return (
    <div className="App">
      {gameState === 'start' && (
        <div className="home-screen">
          <div className="home-header">
            <h1 className="game-title">宮崎県文化・伝統クイズ</h1>
            <img src="/mv.png" alt="宮崎県" className="home-image" />
            <p className="game-description">
              宮崎県の文化・伝統に関するクイズに挑戦しよう！
            </p>
            <p className="game-subtitle">挑戦したいセットを選んでください（各セット10問）</p>
          </div>

          <div className="sets-grid">
            {quizSets.map((set) => (
              <div key={set.id} className="set-card">
                <div className="set-number">{set.category}</div>
                <h3 className="set-title">{set.title.replace(/^セット\d+:\s*/, '')}</h3>
                <div className="set-questions-count">10問</div>
                <div className="set-card-buttons">
                  <button
                    className="set-challenge-button"
                    onClick={() => handleSelectSet(set)}
                  >
                    問題に挑戦
                  </button>
                  <button
                    className="set-ranking-button"
                    onClick={() => handleShowRanking(set.id)}
                  >
                    ランキング
                  </button>
                </div>
              </div>
            ))}
          </div>

          <button className="ranking-button-home" onClick={handleShowRanking}>
            ランキングを見る
          </button>

          <footer className="footer">
            <p className="copyright">© 2025 ひなたAI研究所</p>
          </footer>
        </div>
      )}

      {gameState === 'quiz' && selectedSet && (
        <Quiz
          quizSet={selectedSet}
          onQuizComplete={handleQuizComplete}
          onBackToHome={handleBackToStart}
        />
      )}

      {gameState === 'result' && selectedSet && (
        <Result
          score={finalScore}
          totalQuestions={selectedSet.questions.length}
          quizSet={selectedSet}
          onRestart={handleRestart}
          onShowRanking={handleShowRanking}
          onBackToHome={handleBackToStart}
        />
      )}

      {gameState === 'ranking' && (
        <Ranking
          onBack={handleBackToStart}
          initialSetId={rankingSetId}
        />
      )}
    </div>
  );
}

export default App;
